export const ColorPicker = () => <div>Color Picker dummy</div>;
